import React from 'react';

import classes from './ExpertAbout.module.scss';

const ExpertAbout = ({ name, description }) => {
	if (!description) return null;

	return (
		<section className={classes['about']}>
			<h2 className={classes['title']}>About {name}</h2>
			<div
				className={classes['description']}
				dangerouslySetInnerHTML={{ __html: description }}
			/>
		</section>
	);
};

export default ExpertAbout;
